module.exports = __webpack_public_path__ + "static/media/less_equal.3eb12cbb.svg";